// @ts-strict-ignore
import { PaymentType, ProductBillingCycle } from 'constants/product-cart';
import {
  getApiUsagePackageAppId,
  getApiUsageProPackageAppId,
  getApiUsageProPlusPackageAppId,
} from 'helpers/applications';
import { getConfig } from 'helpers/config';
import type { Product } from 'interfaces/product-cart';

interface IGetSuggestedItems {
  forceAppsInstall: boolean;
}

const getApiUsagePackageSuggestedItems = (forceAppsInstall: boolean): Product[] => {
  const { publicDevMarketplace } = getConfig();

  const packages = [
    {
      id: getApiUsageProPlusPackageAppId(),
      name: 'Pro+ API requests package',
      description: 'A monthly package of 500,000 API requests with a one-time API specialist session.',
      iconAppId: 'n4Pc7OJvg',
      iconFileId: 'BSeN6J1DR',
      slug: 'pro-api-requests-package-1',
      priceInCents: 14999,
    },
    {
      id: getApiUsageProPackageAppId(),
      name: 'Pro API requests package',
      description: 'A monthly package of 500,000 API requests.',
      iconAppId: 'JJQF_vpDR',
      iconFileId: 'Bj756J1vg',
      slug: 'pro-api-requests-package',
      priceInCents: 14999,
    },
    {
      id: getApiUsagePackageAppId(),
      name: 'Essential API requests package',
      description: 'A monthly package of 100,000 API requests.',
      iconAppId: 'bZReQvtDR',
      iconFileId: 'F4nFe11Dg',
      slug: 'essential-prepaid-api-package',
      priceInCents: 2999,
    },
  ];

  return packages.map(({ id, name, description, iconAppId, iconFileId, slug, priceInCents }) => ({
    id,
    name,
    description,
    icon: `https://cdn.files-text.com/global/api/developers/img/applications/${iconAppId}/icons/${iconFileId}-480x480.png`,
    url: `${publicDevMarketplace}apps/${slug}/`,
    trialDays: 0,
    purchasedAt: null,
    isMarkedForInstall: forceAppsInstall,
    isMarkedForUninstall: false,
    plans: [
      {
        id: 'pay-monthly-per-organization',
        type: PaymentType.PerOrganization,
        billingCycle: ProductBillingCycle.Monthly,
        selected: true,
        discount: 0,
        price: {
          initial: priceInCents,
          regular: priceInCents,
          discount: 0,
          total: priceInCents,
        },
      },
    ],
  }));
};

export const getSuggestedItemsArray = (
  { forceAppsInstall }: IGetSuggestedItems = { forceAppsInstall: false },
): Product[] => [
  {
    id: 'analytics',
    name: 'Google Analytics',
    description: 'The integration lets you track chats and measure conversion in your Google Analytics.',
    icon: 'https://cdn-labs.livechat-static.com/api/file/developers/img/applications/analytics/Rnh6aRDiR-icon-480x480.png',
    url: 'https://www.livechat.com/help/log-live-chat-data-with-google-analytics/',
    trialDays: 0,
    purchasedAt: null,
    isMarkedForInstall: forceAppsInstall,
    isMarkedForUninstall: false,
    plans: [
      {
        id: 'pay-monthly-per-organization',
        type: PaymentType.PerOrganization,
        billingCycle: ProductBillingCycle.Monthly,
        selected: true,
        discount: 0,
        price: {
          initial: 500,
          regular: 500,
          discount: 0,
          total: 500,
        },
      },
      {
        id: 'pay-yearly-per-organization',
        type: PaymentType.PerOrganization,
        billingCycle: ProductBillingCycle.Annually12,
        selected: false,
        discount: 15,
        price: {
          initial: 6000,
          regular: 6000,
          discount: 900,
          total: 5100,
        },
      },
    ],
  },
  ...getApiUsagePackageSuggestedItems(forceAppsInstall),
];
